import type { ReactElement, ReactNode } from "react";
import React, { cloneElement } from "react";

interface ConditionalWrapperProps {
  /** When to wrap children */
  condition: boolean;
  /** Wrapper element */
  wrapper: ReactElement;
  children: ReactNode;
}

const ConditionalWrapper: React.FC<ConditionalWrapperProps> = ({
  condition,
  wrapper,
  children,
}) => {
  if (condition) {
    return cloneElement(wrapper, undefined, children);
  }
  return children;
};

ConditionalWrapper.displayName = "ConditionalWrapper";

export default ConditionalWrapper;
